    import React, { useEffect, useState } from 'react';
    import { Plus, TrashFill } from 'react-bootstrap-icons';
    import Select from 'react-select';

    // add styles to the table
    import './CustomizableTableForAddAndEdit.css';

    interface Column {
        key: string;
        label: string;
        inputType?: React.ReactElement;
        disable?: boolean;
        customStyles?: React.CSSProperties; // Use a more appropriate type for custom styles
        customStyleForBody?: React.CSSProperties;
    }


    interface DataRow {
        [key: string]: any;
    }

interface ReusableTableProps {
    columns: Column[];
    initialData: DataRow[];
    dataFromAPI: DataRow[];
    filterColumn: string;
    tableDataFilteredFromCustomDropdown?: any;
    customClassName?: string;
    errorMessage?: string;
    conditionalAppearanceOfTable?: boolean;
    showActions?: boolean; // for Actions column visibility
    showAddLineButton?: boolean; //for Add Line button visibility
    showSearchInputField?:boolean;
}

const CustomizableTableForAddAndEdit: React.FC<ReusableTableProps> = ({
    columns,
    initialData,
    dataFromAPI,
    filterColumn,
    tableDataFilteredFromCustomDropdown,
    customClassName,
    errorMessage,
    conditionalAppearanceOfTable,
    showActions = true, // Default to true
    showAddLineButton = true, // Default to true
    showSearchInputField= false
}) => {
    const [data, setData] = useState<DataRow[]>(
        tableDataFilteredFromCustomDropdown && tableDataFilteredFromCustomDropdown.length > 0
            ? tableDataFilteredFromCustomDropdown
            : initialData
    );

    useEffect(() => {
        if (tableDataFilteredFromCustomDropdown && tableDataFilteredFromCustomDropdown.length > 0) {
            setData(tableDataFilteredFromCustomDropdown);
        } else {
            setData(initialData);
        }
    }, [tableDataFilteredFromCustomDropdown, initialData]);

    const addRow = () => {
        const newRow: DataRow = {};
        columns.forEach(column => {
            newRow[column.key] = '';
        });
        setData([...data, newRow]);
    };

    const handleChange = (index: number, key: string, value: any, valueFromCustomDropDown?: any) => {
        let updatedData = [...data];
        const valueToUse = valueFromCustomDropDown || value;

        if (key === filterColumn) {
            const matchedRow = dataFromAPI.find(item => item[filterColumn] === valueToUse);
            if (matchedRow) {
                updatedData[index] = { ...matchedRow };
            } else {
                updatedData[index] = { ...updatedData[index], [key]: valueToUse };
            }
        } else {
            updatedData[index] = { ...updatedData[index], [key]: valueToUse };
        }

        setData(updatedData);
    };

    const deleteRow = (index: number) => {
        const updatedData = data.filter((_, i) => i !== index);
        setData(updatedData);
    };

    const getSelectedOption = (options: any[], value: string) => {
        return options.find(option => option.value === value) || null;
    };

    return (
        <div className={customClassName}>
            <table className="sph-table table transferDetailsTable  table-striped ">
                <thead>
                    <tr>
                        {columns.map((col, index) => (
                            <th key={index} style={col.customStyles ? col.customStyles : {}}>{col.label}</th>
                        ))}
                        {showActions && <th className="actions text-center">Actions</th>}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {columns.map((col, colIndex) => (
                                <td key={colIndex} style={col.customStyleForBody ? col.customStyleForBody : {}}>
                                    {rowIndex < initialData.length && col.disable ? (
                                        <span className="my-auto">{row[col.key]}</span>
                                    ) : col.inputType && col.inputType.type === Select ? (
                                        React.cloneElement(col.inputType, {
                                            value: getSelectedOption(col.inputType.props.options, row[col.key]),
                                            onChange: (selectedOption: any) =>
                                                handleChange(rowIndex, col.key, selectedOption ? selectedOption.value : ''),
                                        })
                                    ) : col.inputType ? (
                                        React.cloneElement(col.inputType, {
                                            value: row[col.key],
                                            onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
                                                handleChange(rowIndex, col.key, e.target.value),
                                        })
                                    ) : (
                                        <span className="my-auto">{row[col.key]}</span>
                                    )}
                                </td>
                            ))}
                            {showActions && (
                                <td className="text-center">
                                    <TrashFill onClick={() => deleteRow(rowIndex)} />
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>

            {showAddLineButton && (
                <div className="d-flex align-items-center mt-auto mb-2">
                    <div
                        className="cursor-pointer ms-2 me-2 mb-2 addline-icon d-flex align-items-center justify-content-center"
                        onClick={addRow}
                    >
                        <Plus />
                    </div>
                    <small className="cursor-pointer fw-bold mb-2" onClick={addRow}>
                        Add Lines
                    </small>
                </div>
            )}
            { showSearchInputField &&(
                <>
                    
                </>
            )}
        </div>

    );
};

export default CustomizableTableForAddAndEdit;
